<template>
  <div
    v-if="person"
    class="passenger-block"
  >
    <div v-if="personIndex === 0">
      <p>Lead Passenger Details</p>
    </div>
    <div v-if="personIndex === 1">
      <p>Travel Companions Details</p>
    </div>

    <div class="person-block">
      <div
        class="person-block-title"
        @click="onClickShowContent"
      >
        <div class="person-block-title-container">
          <i class="material-icons mr-2"></i>
          <p>{{ person.title }} {{ person.firstname }} {{ person.surname }}</p>
        </div>
        <span>{{ expandSymbol }}</span>
      </div>
    </div>

    <div v-show="showContent">  
      <Person :person="person" />
      <Passport :person="person" />
    </div>  
  </div>
</template>

<script>
import Person from './person'
import Passport from './passport'
export default {
  components: {
    Person,
    Passport
  },
  props: {
    person: {
      type: Object,
      default: null
    },
    personIndex: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      showContent: false,
    
    }
  },
  computed: {
    expandSymbol: function () {
      return this.showContent ? '-' : '+'
    }
  },
  methods: {
    onClickShowContent() {
      this.showContent = !this.showContent
    }
  }  
};
</script>

<style>
@import "./styles.scss";
</style>
